import * as React from "react"; 
 
 
import App from "./App";

  
class AiiApp extends React.Component {
    public render() {
        return (
      
            <App />
      
        );
    }
}

export default AiiApp;
